module.exports = __webpack_public_path__ + "img/Enoturismo_banners-mobile.db97287d.jpg";